import * as React from 'react';
import {observer} from 'mobx-react';
import {action, computed, observable} from 'mobx';
import {DATAResetPassword, DATAActivateAccount} from 'data/data';
import {IPasswordStrength, PasswordField} from 'components/widgets/PasswordField';
import {IEIncompatible} from './widgets/IEIncompatible';
import * as EmailValidator from 'email-validator';

import './Login.pcss';
import {UIState} from 'data/UIState';
import {UnderLogin} from "components/login/UnderLogin";
import {PageEnums} from "components/nav/PageEnums";
import {createRef} from "react";
import {Alert} from "data/Alert";
import {ExtTopper} from "./login/ExtTopper";
import {getUrlParameter} from "utils";
import {SSOPanel} from "components/login/SSOPanel";

declare var $:any;
declare var document:any;

const subPanels = {
	reset:'reset',
	resetRequestSent:'resetRequestSent',
	login:'login',
	activate:'activate',
	activateRequestSent:'activateRequestSent',

}

interface ILoginProps {
}

@observer
class Login extends React.Component<ILoginProps> {

	@observable subPanel:string;
	@observable email:string = '';
	@observable password:string = '';
	@observable passwordStrength:IPasswordStrength|null = null;
	@observable passwordMessage:string|null = null;
	@observable emailIsInvalid:boolean = false;
	@observable passwordIsInvalid:boolean = false;
	@observable message = "";
	@observable loginError;
	h1Ref;

	constructor(props:ILoginProps) {
		super(props);
		this.h1Ref = createRef()

		// GET MESSAGE AND CLEAR IT
		this.message = "" + getUrlParameter('message');
		if(this.message) {
			window.history.pushState({}, document.title, "/" );
		}

		this.loginError = ""+ getUrlParameter('error');

	}
	//
	// @computed get loginErrorDetails() {
	// 	if("Account disabled"===this.loginError) {
	// 		return "Please contact your company's technology team to resolve.";
	// 	}	else if("Email required"===this.loginError) {
	// 		return "An email address must be provided by your company's sign on. Please contact your company's technology team to resolve.";
	// 	}	else if("User not authenticated"===this.loginError) {
	// 		return "No account was found associated with this .";
	// 	} else {
	// 		return "There are no additional details on how to resolve this problem.";
	// 	}
	// }

	handleClick = () => {
		this.login($('#login_email').val(),$('#login_password').val());
	}

	componentDidMount() {
		if(this.h1Ref && this.h1Ref.current) {
			console.log("Login componentDidMount focus");
			this.h1Ref.current.focus();
		}
	}

	login = (email, password) => {
		UIState.attemptLogin(email, password)
			.then(()=>{
				UIState.loadDashboard();
			})
			.catch((err)=>{
				console.log(err);
				if(err && err.hasOwnProperty('errorCode') && err.errorCode==='VENDOR-NOT-PARTICIPANT') {
					window.location.pathname = 'vendor.html';
					// window.location.assign(window.location.protocol + "//"
					// 		+ window.location.hostname
					// 		+ (window.location.port!='443' && window.location.port!=='80' ? ":"+window.location.port : "") + "/"
					// 		+ 'vendor.html'
					// );
				} else {
					Alert.alert("Sign in failed");
				}
			});
	}

	handleActivate = () => {

		// Check email address
		this.emailIsInvalid = !EmailValidator.validate(this.email);
		if(this.emailIsInvalid) {
			if(!this.email || 0===this.email.trim().length) {
				Alert.alert("Your email address is required to activate your account.");
				return;
			} else {
				Alert.alert("Your email address does not appear to be valid. Please make sure it is entered correctly and try again.");
				return;
			}
		}

		// check password
		if(!this.passwordStrength || this.passwordStrength.id<1) {
			this.passwordMessage = "Your password is too weak. It must be 8 or more characters long and contain 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.";
			Alert.alert(this.passwordMessage);
			this.passwordIsInvalid = true;
			return;
		} else {
			this.passwordIsInvalid = false;
		}

		if(!this.emailIsInvalid && !this.passwordIsInvalid) {
			DATAActivateAccount(this.email, this.password)
				.then(action(()=>{
					this.password = '';
					this.showActivateAccountRequestSentSubPanel();
				}))
				.catch(()=>{
					Alert.alert('Failed to contact server in order to activate your account. Maybe you are not connected to the Internet. Please try again.');
				});
		}
	}

	handleReset = () => {

		// Check email address
		this.emailIsInvalid = !EmailValidator.validate(this.email);
		if(this.emailIsInvalid) {
			if(!this.email || 0===this.email.trim().length) {
				Alert.alert("Your email address is required for a password reset.");
				return;
			} else {
				Alert.alert("Your email address does not appear to be valid. Please make sure it is entered correctly and try again.");
				return;
			}
		}

		// check password
		if(!this.passwordStrength || this.passwordStrength.id<1) {
			this.passwordMessage = "Your password is too weak. It must be 8 or more characters long and contain 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.";
			Alert.alert(this.passwordMessage);
			this.passwordIsInvalid = true;
			return;
		} else {
			this.passwordIsInvalid = false;
		}

		if(!this.emailIsInvalid && !this.passwordIsInvalid) {
			DATAResetPassword(this.email, this.password)
				.then(action(()=>{
					this.password = '';
					this.showResetRequestSentSubPanel();
				}))
				.catch(()=>{
					Alert.alert('Failed to contact the server in order to reset your password! Maybe you are not connected to the Internet. Please try again.');
				});
	  }
	}

	showActivateAccountRequestSentSubPanel = () => {
		this.subPanel = subPanels.activateRequestSent;
		console.log("Login showActivateAccountRequestSentSubPanel focus");

		this.h1Ref.current.focus();
		this.scrollTop();
	}

	showResetRequestSentSubPanel = () => {
		this.subPanel = subPanels.resetRequestSent;
		console.log("Login showResetRequestSentSubPanel focus");

		this.h1Ref.current.focus();
		this.scrollTop();
	}

	showResetSubPanel = () => {
		this.subPanel = subPanels.reset;
		console.log("Login showResetSubPanel focus");

		this.h1Ref.current.focus();
		this.scrollTop();
	}

	showLoginSubPanel = () => {
		this.subPanel = subPanels.login;

		console.log("Login showLoginSubPanel focus");

		this.h1Ref.current.focus();
		this.scrollTop();
	}
	
	private scrollTop = () => {
		console.log("Login scrollTop");

		document.querySelector('.inner').scrollTop = 0;
	}

	handleRegisterClick = () => {
		if(UIState.settings.USE_ELIGIBILITY_FILE) {
			this.subPanel= subPanels.activate;
		} else {
			UIState.currentPage = PageEnums.register;
		}
	}

	render() {

		// RESET REQUEST SENT
		if(subPanels.resetRequestSent===this.subPanel) {
			return (
				<LoginComponent settings={UIState.settings} handleRegisterClick={this.handleRegisterClick}>
					<div className="above-fields">
						<h1 role="heading" aria-level={1} tabIndex={0} ref={this.h1Ref} >Almost done, check your email!</h1>
						<p>An email was sent to <strong>{this.email}</strong>. Follow the instructions in the email to complete your password reset.</p>
						<p style={{marginTop:'16px'}}>If you do not see this email in your inbox, make sure to check your SPAM folder. If you still cannot find it,
							email <a href={"mailto:strive@well-concepts.com?subject=Account%20Support"}>strive@well-concepts.com</a> for help.</p>
					</div>
					<p><a href="#" onClick={this.showLoginSubPanel}>Go to sign in</a></p>
				</LoginComponent>
			)			
		}

		// RESET
		else if(subPanels.reset===this.subPanel) {
			return (
				<LoginComponent settings={UIState.settings} handleRegisterClick={this.handleRegisterClick}>
					<div className="above-fields">
						<h1 role="heading" aria-level={1} tabIndex={0} ref={this.h1Ref}>Reset your password</h1>
						<p>While we can't send you your existing password, you may use this form to create a new one.</p>
					</div>
					<div className="fields">
						<label htmlFor="email">Email</label>
						<input
							id="email"
							autoComplete={"username"}
							type="email"
							name="email"
							value={this.email}
							placeholder="enter email"
							onChange={(e) => {
								this.email = e.target.value;
							}}
							className={`email${this.emailIsInvalid ? ' error' : ''}`}
						/>
						{/*<div className="divider"/>*/}
						<label htmlFor="password">Create a new password</label>
						<p className="desc" id={"password-desc"}>Your password must be 8 or more characters long and contain 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.</p>
						<PasswordField
							id="password"
							placeholder={"enter new password"}
							inputName="password"
							email={this.email}
							password={this.password}
							onPasswordChange={(password, passwordStrength) => {
								this.passwordStrength = passwordStrength;
								this.password = password;
							}}
							error={this.passwordIsInvalid}
						/>
					</div>
					<div className={'login-actions centered'}>
						<button className="sign-in" value="Reset" onClick={this.handleReset}>Reset Password</button>
					</div>
					<a className={"go-back"} onClick={this.showLoginSubPanel}>Go to sign in</a>
				</LoginComponent>
			);
		}


		// ACTIVATE REQUEST SENT
		else if(subPanels.activateRequestSent===this.subPanel) {
			return (
				<LoginComponent settings={UIState.settings} handleRegisterClick={this.handleRegisterClick}>
					<div className="above-fields">
						<h1 role="heading" aria-level={1} tabIndex={0} ref={this.h1Ref} >Almost done, check your email!</h1>
						<p>An email was sent to <strong>{this.email}</strong>. Follow the instructions in the email to complete your account activation.</p>
						<p style={{marginTop:'16px'}}>If you do not see this email in your inbox, make sure to check your SPAM folder. If you still cannot find it,
							email <a href={"mailto:strive@well-concepts.com?subject=Account%20Support"}>strive@well-concepts.com</a> for help.</p>
					</div>
					<p><a href="#" onClick={this.showLoginSubPanel}>Go to sign in</a></p>
				</LoginComponent>
			)
		}


		// ACTIVATE ACCOUNT
		else if(subPanels.activate===this.subPanel) {
			return (
				<LoginComponent settings={UIState.settings} handleRegisterClick={this.handleRegisterClick}>
					<div className="above-fields">
						<h1 role="heading" aria-level={1} tabIndex={0} ref={this.h1Ref}>Activate your account</h1>
					</div>
					<div className="fields">
						<label htmlFor="email">Email</label>
						<p className="desc" id={"email-desc"}>Use the email address that was granted access.</p>
						<input
							id="email"
							autoComplete={"username"}
							type="email"
							name="email"
							value={this.email}
							placeholder="enter email"
							onChange={(e) => {
								this.email = e.target.value;
							}}
							className={`email${this.emailIsInvalid ? ' error' : ''}`}
							aria-describedby={"email-desc"}
						/>
						{/*<div className="divider"/>*/}
						<label htmlFor="password">Create a strong password</label>
						<p className="desc" id={"password-desc"}>Your password must be 8 or more characters long and contain 3 of the following: an uppercase letter, a lowercase letter, a special character, and a number.</p>
						<PasswordField
							id="password"
							placeholder={"enter password"}
							inputName="password"
							email={this.email}
							password={this.password}
							onPasswordChange={(password, passwordStrength) => {
								this.passwordStrength = passwordStrength;
								this.password = password;
							}}
							error={this.passwordIsInvalid}
							aria-describedby={"password-desc"}
						/>
					</div>

					<div className={'login-actions centered'}>
						<button className="sign-in" value="Activate" onClick={this.handleActivate}>Activate Account</button>
					</div>

					<a className={"go-back"} onClick={this.showLoginSubPanel}>Go to sign in</a>

				</LoginComponent>
			);
		}


		// NORMAL LOGIN PANEL
		else {
			// Login Panel
			let fieldsStyle:any = {
				border:'none',
			};
			let inputStyle = {};
				return (
					<LoginComponent settings={UIState.settings} handleRegisterClick={this.handleRegisterClick}>
						<div>
						{!UIState.settings.ENABLE_SAML_SSO ?
							<div style={{display:'flex', gap:'36px'}}>
								<div style={{flex:'1 1 0'}}>

								{UIState.settings.USE_ELIGIBILITY_FILE &&
									<div className={'login-trusted-access'}>
										<div>
											<img alt="" aria-hidden={"true"} src={"img/trusted access@4x.png"} />
										</div>
										<div>
											<h3>Trusted access</h3>
											<p>Accounts have been set up using a list of eligible emails. First time here? <a onClick={this.handleRegisterClick}>Activate your account</a></p>
										</div>
									</div>
								}

								{!UIState.settings.USE_ELIGIBILITY_FILE && UIState.settings.PLATFORM_OPEN_FOR_REG && !UIState.settings.PLATFORM_OPEN &&
									<div className={'login-trusted-access'}>
										<div>
											<img alt="" aria-hidden={"true"} src={"img/trusted access@4x.png"}/>
										</div>
										<div>
											<h3>Registration Open</h3>
											<p>The first day is {UIState.settings.PLATFORM_OPEN_DATE}, but registration is now open. If you haven't signed up yet, <a onClick={this.handleRegisterClick}>Sign Up</a></p>
										</div>
									</div>
								}

								{this.message && <div className={"login-message"}>{this.message}</div>}
								<div className="above-fields">
									<h1 role="heading" aria-level={1} tabIndex={0} ref={this.h1Ref}>Sign in</h1>
								</div>
								<div className="fields" style={fieldsStyle}>
									<label htmlFor="email">Email</label>
									<input
										type="email"
										name="email"
										id="login_email"
										placeholder="email"
										className="email"
										style={inputStyle}
										autoComplete="username"
									/>
									{/*<div className="divider" style={dividerStyle}/>*/}
									<label htmlFor="password">Password</label>
									<input
										type="password"
										name="password"
										id="login_password"
										placeholder="password"
										className="password"
										style={inputStyle}
										autoComplete="password"
									/>
								</div>

								<div className={'login-actions'}>
									<button className="sign-in" value="Login" onClick={this.handleClick}>Sign In</button>
									<a onClick={this.showResetSubPanel}>Forgot password?</a>
								</div>

								{!UIState.settings.USE_ELIGIBILITY_FILE && UIState.settings.PLATFORM_OPEN &&
									<div className={'login-signup'}>
										<span>Don’t have a Wellness Concepts account?</span><a onClick={this.handleRegisterClick}>Sign Up</a>
									</div>
								}

								{UIState.settings.ENABLE_VENDOR_LOGIN &&
									<div className={'login-vendor-system'}>
										If you are a vendor, use the <a href={"vendor.html"}>vendor system</a>.
									</div>
								}

								</div>
								{/*<div style={{flex:'1 1 0'}}>*/}
								{/*	<SSOPanel loginError={this.loginError} />*/}
								{/*</div>*/}
							</div>
						:
							<SSOPanel loginError={this.loginError} />
						}
						</div>
					</LoginComponent>
				);

		}
	}
}


const LoginComponent = (props) => {
const bg = {backgroundImage:`url('${props.settings.BG}')` };

return (
	<div className="loginContainer">
		<div className="inner">
			<div className="login" style={bg}>
				<div className="login-box">
					<ExtTopper />
					{props.children}
					<IEIncompatible message="Wellness Concepts will work with your browser, but certain features may not be available, and you may experience malfunctions." />
				</div>
			</div>
			{/*<UnderBox settings={props.settings} handleRegisterClick={props.handleRegisterClick} />*/}
			<UnderLogin />
		</div>
	</div>
)
};


export {Login};
